//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('holidaysView', {
//        templateUrl: 'views/components/views/holidaysView/holidaysView.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'holidaysViewService', 'logisticService', function (stateService, utilityService, holidaysViewService, logisticService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                setting: {},
//                selectListCountries: [],
//                itemsListYears: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await holidaysViewService.getSetting())[0];

//                loadHolidayYears();
//            }

//            async function loadCountries() {
//                vm.model.selectListCountries = (await logisticService.listCountries());
//            }

//            async function loadHolidayYears() {
//                if (utilityService.validateParmsValue(vm.model.setting.country_id) !== true) return;

//                vm.model.itemsListYears = (await holidaysViewService.listHolidayYears({ country_id: vm.model.setting.country_id }));
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI BUTTON DIRECTION FUNCTION

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'holiday':
//                        go({
//                            p2_holyday_keyno: '0',
//                            country_id: vm.model.setting.country_id
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI BUTTON DIRECTION FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'country_id':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.country_id) !== true) return;

//                        vm.model.setting.country_id = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.country_id) !== true) return;

//                        loadHolidayYears();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//                loadCountries();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
